<div class="container" id="support-site-container">
    <p class="accessTitle"> {{'lang.accessRestricted' | translate}} </p>
    <p class="accessDetail m-0">{{'lang.restrictedMassage' | translate}} </p>
    <p class="accessDetail mt-0"> {{ 'lang.restrictedLink' | translate}}
        <span> &nbsp;<a class="itLink">{{'lang.itContact' | translate}}</a></span>
    </p>

    <p class="accessTitle">
        <button class=" btn signin-btn btn-signin pl-5 pr-5" (click)="signOut()">
            <span class="logout">{{'lang.log_out' | translate}}</span>
        </button>
    </p>
</div>